// @flow

import { createSelector } from 'reselect'
import { prop, propOr, pathOr, mergeDeepRight } from 'ramda'

import { getConfig, getP2PSettings as getP2PDefaultSettings } from '@alphaott/app-main/selectors'
import { isEnabled } from '@alphaott/app-main/models/utils/config'

export const getUiSettings = createSelector([getConfig], (config: Object): Object => {
  const bootloaderVersion = prop('bootloaderVersion', window)

  const basePath = ['platform', 'smarttv', 'ui']
  const overridePath = ['platform', 'smarttv', 'overrides', bootloaderVersion, 'ui']

  const baseUi = pathOr({}, basePath, config)
  const overrideUi = pathOr({}, overridePath, config)

  return mergeDeepRight(baseUi, overrideUi)
})

export const getP2PSettings = createSelector(
  [getConfig, getP2PDefaultSettings],
  (config: Object, defaultP2PSettings: Object): Object =>
    mergeDeepRight(defaultP2PSettings, pathOr({}, ['platform', 'smarttv', 'p2p'], config)),
)

export const isP2PEnabled = createSelector([getP2PSettings], (p2p: Object): boolean =>
  isEnabled(p2p),
)

export const getP2PConfig = createSelector([getP2PSettings], (p2p: Object): Object =>
  propOr({}, 'config', p2p),
)

const DEFAULT_ANALYTICS_INTERVAL = 60

export const getP2PAnalytics = createSelector([getP2PSettings], (p2p: Object): Object =>
  propOr({}, 'analytics', p2p),
)

export const isP2PAnalyticsEnabled = createSelector(
  [getP2PAnalytics],
  (analytics: Object): boolean => isEnabled(analytics),
)

export const getP2PAnalyticsInterval = createSelector(
  [getP2PAnalytics],
  (analytics: Object): number => propOr(DEFAULT_ANALYTICS_INTERVAL, 'interval', analytics),
)
